import { useCallback } from 'react';
import type { TRAFFIC_UPSELL_BANNER } from '@hotjar/upsell';
import { TRAFFIC_UPSELL_BANNER_TYPE_DATA, TrafficUpsellBanner } from '@hotjar/upsell';
import { upsell } from '@hotjar/webapp/domains/revenue/upsell';
import { useCurrentSite } from '@hotjar/site';
import { useCoverageUpsellAlert } from '../CoverageUpsell/useCoverageUpsellAlert';

interface TrafficAndCoverageBannerProps {
  type: TRAFFIC_UPSELL_BANNER;
  track: {
    page: string;
    trackViewElement: (
      eventName: string,
      uiPosition: string,
      additionalData: Record<string, string>,
    ) => void;
    trackClick: (
      eventName: string,
      uiPosition: string,
      additionalData: Record<string, string>,
    ) => void;
  };
}

export const TrafficAndCoverageBanner = ({
  type,
  track,
}: TrafficAndCoverageBannerProps): JSX.Element => {
  const { data: site } = useCurrentSite();

  const openUpsellModal = useCallback(() => {
    if (site) {
      // We ignore the referrer coming from useCoverageUpsellAlert as it's not type safe
      // It will be refactored later
      const { referrer } = TRAFFIC_UPSELL_BANNER_TYPE_DATA[type];
      upsell({
        site,
        referrer,
        additionalTrackingData: {
          state_event_was_triggered_on: track.page,
        },
      });
    }
  }, [type, site, track.page]);

  useCoverageUpsellAlert(track, openUpsellModal);

  return <TrafficUpsellBanner upsell={upsell} type={type} />;
};
